module.exports={author:"Gabrielle Bates",date:"02/09/2021",publishDate:"10/17/2020",highlighted:!1,tags:"",title:"Ownership"};